import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { values, boardMembers } from "../data/content";
import HolidayPopup from "../components/home/HolidayPopup";
import BtsoHaberSection from "../components/home/BtsoHaberSection";

interface HomeEtkinlik {
  id: string;
  baslik: string;
  tarih: string;
  yer?: string;
  saat?: string;
  kategori?: string;
  aciklama?: string;
}

interface HomeDuyuru {
  id: string;
  baslik: string;
  tarih: string;
  aciklama?: string;
}

// ─── Hızlı Erişim Linkleri ───────────────────────────────────────────────────
const quickLinks = [
  { icon: "fa-solid fa-user-plus", label: "Üyelik Başvurusu", href: "/destek/uyelik" },
  { icon: "fa-solid fa-calendar-days", label: "Etkinlikler", href: "/faaliyetler/etkinlikler" },
  { icon: "fa-solid fa-graduation-cap", label: "Burs Başvurusu", href: "/destek/burs" },
  { icon: "fa-solid fa-hand-holding-heart", label: "Gönüllü Ol", href: "/destek/gonulluluk" },
  { icon: "fa-regular fa-newspaper", label: "Haberler", href: "/faaliyetler/haberler" },
];

// ─── Slider verileri ─────────────────────────────────────────────────────────
const slides = [
  {
    id: 0,
    image: "",
    // Gerçek fotoğraf yerine marka renklerinde gradient — harici görsele bağımlı değil, eğitim temasını vurgular.
    bgGradient: "linear-gradient(135deg, #0F172A 0%, #3A0A1C 55%, #4E0F26 100%)",
    // Sağ tarafta gösterilen ders görseli (sol taraftaki metin alanının boş kalan yanına).
    sideImage: "/images/egitim/ders-gorsel.jpg",
    // İlk slayt normalden 2 kat uzun gösterilsin (diğerleri varsayılan süreyle geçer).
    durationMs: 10000,
    badge: "Eğitim Bursu",
    title: ["2026–2027\nEğitim Bursu Başvuruları"],
    titleColors: ["white"],
    desc: "Bursa Trabzonlular Derneği olarak eğitimin, bir gencin hayatını değiştirebilecek en güçlü değerlerden biri olduğuna inanıyoruz. Başarılı ve geleceğe umutla bakan üniversite öğrencilerimizin yolculuğuna destek olmak için burs başvuruları başladı.",
    personPhoto: boardMembers[0]?.image || "",
    personName: boardMembers[0]?.name || "",
    personRole: "Dernek Başkanı",
    btnPrimary: { label: "Burs Başvurusu", href: "/destek/burs" },
    btnSecondary: null as { label: string; href: string } | null,
    accent: "#D4A017",
  },
  {
    id: 1,
    image: "https://upload.wikimedia.org/wikipedia/commons/7/7c/Panoromik_Trabzon.jpg",
    overlay: "linear-gradient(135deg, rgba(10,22,40,0.75) 0%, rgba(15,42,80,0.65) 100%)",
    badge: "Trabzon Panoraması",
    title: ["Kökümüz Trabzon,\nYuvamız Bursa,\nYönümüz Gelecek"],
    titleColors: ["white"],
    desc: "Geçmişten aldığımız güçle, saygıyla büyüyen ve dayanışmayla güçlenen bir hemşehri ocağında herkese yer var.",
    btnPrimary: { label: "Üyelik Başvurusu", href: "/destek/uyelik" },
    btnSecondary: { label: "Bizi Tanıyın", href: "/kurumsal/hakkimizda" } as { label: string; href: string } | null,
    accent: "#D4A017",
  },
  {
    id: 2,
    image: "https://upload.wikimedia.org/wikipedia/commons/d/db/Sumela_From_Across_Valley.JPG",
    overlay: "linear-gradient(135deg, rgba(26,10,10,0.75) 0%, rgba(78,15,38,0.65) 100%)",
    badge: "Sümela Manastırı",
    title: ["Trabzon'un Değerleri\nBursa'da Yaşıyor"],
    titleColors: ["white"],
    desc: "Horon, kemençe, hamsi sofraları ve yüzyıllık geleneklerimizi yaşatmak için bir aradayız.",
    btnPrimary: { label: "Kültürümüzü Keşfet", href: "/tarihce/kultur" },
    btnSecondary: { label: "Tarihçemiz", href: "/tarihce/hikaye" },
    accent: "#D4A017",
  },
  {
    id: 3,
    image: "https://upload.wikimedia.org/wikipedia/commons/7/7e/Uzung%C3%B6l_lake_and_town.jpg",
    overlay: "linear-gradient(135deg, rgba(7,26,15,0.75) 0%, rgba(13,51,32,0.65) 100%)",
    badge: "Uzungöl",
    title: ["Geleceği Birlikte\nİnşa Ediyoruz"],
    titleColors: ["white"],
    desc: "Burs, mentorluk ve kariyer desteğiyle gençlerimizin yanındayız. Yarın bugün başlar.",
    btnPrimary: { label: "Gençlik Sayfası", href: "/topluluk/genclik" },
    btnSecondary: { label: "Burs Başvurusu", href: "/destek/burs" },
    accent: "#4ade80",
  },
  {
    id: 4,
    image: "https://upload.wikimedia.org/wikipedia/commons/8/89/Ayasofya_Cami_Trabzon.jpg",
    overlay: "linear-gradient(135deg, rgba(10,15,32,0.75) 0%, rgba(15,76,129,0.65) 100%)",
    badge: "Trabzon Ayasofyası",
    title: ["500+ Üye,\nBir Yürek,\nBir Aile"],
    titleColors: ["white"],
    desc: "Bursa'ya taşınan her Trabzonlu bu ailenin bir parçası. Kapımız herkese açık.",
    btnPrimary: { label: "Aramıza Katıl", href: "/destek/uyelik" },
    btnSecondary: { label: "Etkinlikler", href: "/faaliyetler/etkinlikler" },
    accent: "#60A5FA",
  },
  {
    id: 5,
    image: "https://upload.wikimedia.org/wikipedia/commons/d/de/Trabzon-sea.jpg",
    overlay: "linear-gradient(135deg, rgba(5,20,35,0.75) 0%, rgba(10,40,70,0.65) 100%)",
    badge: "Karadeniz Kıyısı",
    title: ["Karadeniz'in Ruhu\nBursa'da Yaşıyor"],
    titleColors: ["white"],
    desc: "Dalgaların sesini, yaylaların kokusunu, Karadeniz'in ruhunu Bursa'ya taşıdık.",
    btnPrimary: { label: "Hakkımızda", href: "/kurumsal/hakkimizda" },
    btnSecondary: { label: "Galeri", href: "/medya/galeri" },
    accent: "#60A5FA",
  },
  {
    id: 6,
    image: "https://upload.wikimedia.org/wikipedia/commons/f/f3/Uzung%C3%B6l%2C_Trabzon.jpg",
    overlay: "linear-gradient(135deg, rgba(10,25,15,0.75) 0%, rgba(20,60,40,0.65) 100%)",
    badge: "Uzungöl — Trabzon",
    title: ["Dayanışma\nGeçmişten Geleceğe\nUzanır"],
    titleColors: ["white"],
    desc: "20 yılı aşkın süredir Bursa'daki Trabzonluları bir araya getiren köklü bir hemşehri ocağı.",
    btnPrimary: { label: "Tarihçemiz", href: "/tarihce/hikaye" },
    btnSecondary: { label: "Üyelik Başvurusu", href: "/destek/uyelik" },
    accent: "#4ade80",
  },
];

// ─── Hero Slider ─────────────────────────────────────────────────────────────
const Hero: React.FC = () => {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);
  // dragOffset: parmak sürükleme sırasında anlık kaydırma miktarı (px)
  const [dragOffset, setDragOffset] = useState(0);
  const touchStartX = useRef<number | null>(null);
  const isDragging = useRef(false);

  const goTo = useCallback((idx: number) => {
    if (transitioning) return;
    setTransitioning(true);
    setCurrent(idx);
    setTimeout(() => setTransitioning(false), 500);
  }, [transitioning]);

  const prev = useCallback(() => goTo((current - 1 + slides.length) % slides.length), [current, goTo]);
  const next = useCallback(() => goTo((current + 1) % slides.length), [current, goTo]);

  // Otomatik geçiş — 5 saniye (slayta özel durationMs varsa onu kullanır; sürükleme sırasında durur).
  // setTimeout kullanılıyor (setInterval değil) çünkü current değişince süre yeniden okunmalı
  // — böylece ilk slayt 2 katı süre kalabiliyor, diğerleri varsayılan sürede geçiyor.
  useEffect(() => {
    if (isDragging.current) return;
    const ms = slides[current].durationMs ?? 5000;
    const timer = setTimeout(next, ms);
    return () => clearTimeout(timer);
  }, [next, current]);

  // Touch handlers — gerçek sürükleme hissi
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
    isDragging.current = true;
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    setDragOffset(e.touches[0].clientX - touchStartX.current);
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const delta = touchStartX.current - e.changedTouches[0].clientX;
    setDragOffset(0);
    isDragging.current = false;
    if (Math.abs(delta) > 50) delta > 0 ? next() : prev();
    touchStartX.current = null;
  };

  const slide = slides[current];

  // Başlık render — tek renk, satır kırılmalarını destekler
  const renderTitle = (s: typeof slides[0]) =>
    s.title[0].split("\n").map((line, i) => (
      <span key={i}>{i > 0 && <br />}{line}</span>
    ));

  return (
    <>
      {/* ── Slider ── */}
      <section
        className="relative w-full overflow-hidden select-none"
        style={{ height: "638px" }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Slayt şeridi — tüm slide'lar yan yana, translateX ile kaydırılır */}
        <div
          className="absolute inset-0 flex"
          style={{
            width: `${slides.length * 100}%`,
            transform: `translateX(calc(${-current * (100 / slides.length)}% + ${dragOffset / slides.length}px))`,
            transition: transitioning && dragOffset === 0 ? "transform 500ms cubic-bezier(0.25,0.46,0.45,0.94)" : "none",
          }}
        >
          {slides.map((s) => (
            <div
              key={s.id}
              className="relative h-full flex-shrink-0"
              style={{ width: `${100 / slides.length}%` }}
            >
              {s.image ? (
                <img
                  src={s.image}
                  alt={s.badge}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              ) : (
                <div className="absolute inset-0" style={{ background: s.bgGradient }} />
              )}
              {s.sideImage ? (
                <img
                  src={s.sideImage}
                  alt=""
                  className="hidden lg:block absolute right-0 top-0 h-full w-1/2 object-contain object-right"
                  style={{ maskImage: "linear-gradient(to right, transparent 0%, black 18%)", WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 18%)" }}
                />
              ) : null}
              <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(0,0,0,0.80) 0%, rgba(0,0,0,0.25) 35%, transparent 65%)" }} />
            </div>
          ))}
        </div>

        {/* İçerik — aktif slide'a göre */}
        <div className="relative z-10 h-full flex flex-col justify-end w-full px-6 xl:px-16 pb-14">
          <div className="max-w-2xl">
            {slide.personPhoto ? (
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={slide.personPhoto}
                  alt={slide.personName}
                  className="w-12 h-12 rounded-full object-cover border-2 border-white/40"
                />
                <div className="text-white/90 text-xs leading-tight">
                  <div className="font-semibold">{slide.personName}</div>
                  <div className="text-white/60">{slide.personRole}</div>
                </div>
              </div>
            ) : null}

            <div className="inline-flex items-center gap-2 border text-white/90 text-xs font-semibold px-4 py-1.5 rounded-full mb-5 uppercase tracking-wider"
              style={{ backgroundColor: `${slide.accent}22`, borderColor: `${slide.accent}55` }}>
              <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ backgroundColor: slide.accent }} />
              {slide.badge}
            </div>

            <h1 className="text-3xl md:text-4xl font-extrabold leading-tight mb-4 text-white">
              {renderTitle(slide)}
            </h1>

            <p className="text-white/65 text-base md:text-lg mb-8 leading-relaxed max-w-lg">
              {slide.desc}
            </p>

            <div className="flex flex-wrap gap-3">
              <Link
                to={slide.btnPrimary.href}
                className="text-white font-semibold px-7 py-3 rounded-md transition-colors flex items-center gap-2 text-sm"
                style={{ backgroundColor: "#4E0F26" }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#3A0A1C")}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#4E0F26")}
              >
                {slide.btnPrimary.label} <i className="fa-solid fa-arrow-right text-xs"></i>
              </Link>
              {slide.btnSecondary ? (
                <Link
                  to={slide.btnSecondary.href}
                  className="border border-white/30 text-white font-semibold px-7 py-3 rounded-md hover:bg-white/10 transition-colors text-sm"
                >
                  {slide.btnSecondary.label}
                </Link>
              ) : null}
            </div>
          </div>
        </div>

        {/* Sol / Sağ ok */}
        <button
          onClick={prev}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white/10 hover:bg-white/25 border border-white/20 rounded-full flex items-center justify-center text-white transition-colors"
        >
          <i className="fa-solid fa-chevron-left"></i>
        </button>
        <button
          onClick={next}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white/10 hover:bg-white/25 border border-white/20 rounded-full flex items-center justify-center text-white transition-colors"
        >
          <i className="fa-solid fa-chevron-right text-xs"></i>
        </button>

        {/* Nokta göstergeleri */}
        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className="transition-all duration-300 rounded-full"
              style={{
                width: i === current ? "28px" : "8px",
                height: "8px",
                backgroundColor: i === current ? slide.accent : "rgba(255,255,255,0.4)",
              }}
            />
          ))}
        </div>

        {/* İstatistikler — sağ alt */}
        <div className="absolute right-8 xl:right-16 bottom-14 hidden lg:flex gap-8">
          {[
            { value: "500+", label: "Üye" },
            { value: "20+", label: "Yıl" },
            { value: "100+", label: "Etkinlik" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-3xl font-extrabold" style={{ color: slide.accent }}>{s.value}</div>
              <div className="text-white/50 text-xs mt-1 uppercase tracking-wider">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Hızlı Erişim Şeridi ── */}
      <div className="w-full" style={{ backgroundColor: "rgba(15,76,129,0.5)", backdropFilter: "blur(4px)" }}>
        <div className="w-full px-6 xl:px-16">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 divide-x divide-white/10">
            {quickLinks.map((ql) => (
              <Link
                key={ql.href}
                to={ql.href}
                className="flex flex-col items-center gap-1.5 py-3.5 px-4 text-white/80 hover:text-white hover:bg-white/10 transition-colors text-center"
              >
                <i className={`${ql.icon} text-xl`} />
                <span className="text-xs font-semibold tracking-wide">{ql.label}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

// ─── Haber Bölümü ────────────────────────────────────────────────────────────
// ─── Burs Duyuru Bölümü ──────────────────────────────────────────────────────
const BursDuyuruSection: React.FC = () => {
  const president = boardMembers[0];
  return (
    <section className="py-16 bg-bg-page border-b border-border-light">
      <div className="w-full px-6 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-2 bg-brand-gold/15 text-yellow-800 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
              <i className="fa-solid fa-graduation-cap" /> Eğitim Bursu
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-text-primary leading-snug">
              2026–2027 Eğitim Bursu Başvuruları
            </h2>
            <p className="text-brand-bordo font-semibold mt-2">
              Başarıyı Birlikte Destekliyor, Geleceğe Birlikte Yatırım Yapıyoruz
            </p>
          </div>

          <div className="space-y-4 text-text-muted leading-relaxed text-justify text-sm">
            <p>
              Bursa Trabzonlular Derneği olarak eğitimin, bir gencin hayatını değiştirebilecek en
              güçlü değerlerden biri olduğuna inanıyoruz.
            </p>
            <p>
              İmkânlarımız sınırlı olsa da başarılı, çalışkan ve geleceğe umutla bakan gençlerimizin
              eğitim yolculuğuna katkıda bulunmayı; bugün destek verdiğimiz öğrencilerimizin yarın
              ülkemize, toplumumuza ve kendilerinden sonra gelen gençlere değer katmasını çok
              önemsiyoruz.
            </p>
            <p>
              Bu anlayışla, 2026–2027 eğitim döneminde belirlenen şartları taşıyan üniversite
              öğrencilerine Bursa Trabzonlular Derneği Eğitim Bursu verilecektir.
            </p>
            <p>
              Burs kontenjanımız, derneğimizin ve hayırseverlerimizin imkânları doğrultusunda
              sınırlıdır. Bu nedenle şartları sağlayan her öğrenciye burs verilemeyebilir. Başvurular
              başarı durumu, öğrencinin ve ailesinin ekonomik koşulları ve derneğimizin burs
              kontenjanı birlikte değerlendirilerek sonuçlandırılacaktır.
            </p>
            <p className="font-medium text-text-primary">Sevgili Öğrencimiz,</p>
            <p>
              Bir sınavda elde edilen başarı yalnızca bir puandan veya sıralamadan ibaret değildir. O
              sonucun arkasında yıllarca verilen emek, vazgeçilmeyen hedefler ve yapılan
              fedakârlıklar vardır.
            </p>
            <p>
              Bursa Trabzonlular Derneği olarak imkânlarımız ölçüsünde bu emeğin yanında olmak
              istiyoruz.
            </p>
            <p>
              Belki bugün senin yoluna küçük bir katkı sağlayacağız. En büyük temennimiz ise yarın
              mesleğini eline aldığında, başarılı olduğunda ve kendi ayaklarının üzerinde durduğunda
              senin de başka bir gencin yolunu aydınlatman.
            </p>
            <p>Çünkü inanıyoruz ki;</p>
            <p className="font-semibold text-text-primary">
              Bir öğrenciye verilen destek, yalnızca bir öğrencinin değil, geleceğin
              desteklenmesidir.
            </p>
          </div>

          {/* Başkan imzası — metnin altında */}
          <div className="flex items-center gap-4 mt-8 pt-6 border-t border-border-light">
            <img
              src="/baskan-foto.jpg"
              alt={president.name}
              className="w-14 h-14 rounded-full object-cover border-2 border-brand-bordo/20"
            />
            <div>
              <div className="font-bold text-text-primary text-sm">{president.name}</div>
              <div className="text-text-soft text-xs">Bursa Trabzonlular Derneği Başkanı</div>
            </div>
          </div>

          <div className="text-center mt-8">
            <Link
              to="/destek/burs"
              className="inline-flex items-center gap-2.5 bg-brand-bordo hover:bg-brand-bordo-dark text-white font-semibold px-7 py-3.5 rounded-lg border-2 border-brand-bordo-dark transition-colors shadow-sm"
            >
              <i className="fa-solid fa-file-signature text-lg" />
              Burs Başvurusu
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

const HaberSection: React.FC = () => (
  <section className="py-16 bg-bg-surface border-b border-border-light">
    <div className="w-full px-6 xl:px-16">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-brand-bordo/10 text-brand-bordo text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            <i className="fa-solid fa-newspaper" /> Haber
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-text-primary leading-snug">
            Kahvaltı Programımızı Gerçekleştirdik
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center">
          <img
            src="/images/haberler/kahvalti-programi.jpg"
            alt="Kahvaltı Programı"
            className="w-full rounded-2xl shadow-sm object-cover"
            style={{ maxHeight: "420px" }}
          />
          <div className="space-y-4 text-text-muted leading-relaxed text-justify text-sm">
            <p>
              Bursa Trabzon Kültür ve Yardımlaşma Derneği olarak, Başkanımız Orhan AYGÜN
              öncülüğünde Yönetim Kurulu üyelerimizin katılımıyla düzenlediğimiz kahvaltı
              programını birlik ve beraberlik içerisinde gerçekleştirdik.
            </p>
            <p>
              Samimi bir ortamda gerçekleştirilen organizasyonumuzda, BTSO Yönetim Kurulu
              Başkanı Sayın İbrahim Burkay ile Milletvekilimiz Sayın Zekeriya Birkan bizleri
              ziyaret ederek programımıza değer katmışlardır.
            </p>
            <p>
              Nazik ziyaretleri ve kıymetli sohbetleriyle bizleri onurlandıran Sayın İbrahim
              Burkay'a ve Sayın Zekeriya Birkan'a teşekkür ediyor; birlik, beraberlik ve
              dayanışma içerisinde şehrimize ve hemşehrilerimize değer katacak çalışmaları
              sürdüreceğimizi ifade ediyoruz.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// ─── Etkinlik Bölümü ─────────────────────────────────────────────────────────
const EtkinlikSection: React.FC = () => {
  const president = boardMembers[0];
  return (
    <section className="py-16 bg-bg-page border-b border-border-light">
      <div className="w-full px-6 xl:px-16">
        {/* Başlık */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-brand-bordo/10 text-brand-bordo text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            <i className="fa-solid fa-calendar-check" /> Faaliyet
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-text-primary leading-snug">
            14–17 Mayıs <span className="text-brand-bordo">Şenliğimize</span> Davet
          </h2>
        </div>

        {/* 2 satır × 3 sütun grid */}
        <div className="grid grid-cols-3 gap-4">
          {/* Satır 1: Başkan mesajı, 1.jpeg, 2.jpeg */}
          <div className="bg-white border border-border-light rounded-2xl p-6 shadow-sm flex flex-col justify-between" style={{ minHeight: "420px" }}>
            <div>
              <p className="text-text-muted leading-relaxed mb-3 text-justify text-sm">
                14–17 Mayıs tarihlerinde gerçekleştireceğimiz muhteşem şenliğimizin hazırlıkları; Ay yıldızlı şanlı Türk Bayrağımızın, gönlümüzün sevdası Trabzonspor'umuzun ve kardeşlik ruhunu taşıyan Bursaspor'umuzun bayraklarının göndere çekilmesiyle başlamıştır.
              </p>
              <p className="text-text-muted leading-relaxed mb-3 text-justify text-sm">
                İnşallah el birliğiyle, gönül birliğiyle; kazasız, belasız ve unutulmaz bir şenliğe hep birlikte imza atacağız.
              </p>
              <p className="text-text-muted leading-relaxed text-justify text-sm">
                Horonun coşkusu, kemençenin sesi ve Karadeniz'in yiğit ruhu Bursa'da yeniden hayat bulacak…
              </p>
            </div>
            <div className="flex items-center gap-3 pt-4 mt-4 border-t border-border-light">
              <img src="/baskan-foto.jpg" alt={president.name} className="w-10 h-10 rounded-full object-cover border-2 border-brand-bordo" />
              <div>
                <div className="font-bold text-text-primary text-sm">{president.name}</div>
                <div className="text-text-muted text-xs">Bursa Trabzonlular Derneği Başkanı</div>
              </div>
            </div>
          </div>
          {[1, 2].map((n) => (
            <div
              key={n}
              className="w-full"
              style={{
                height: "420px",
                backgroundImage: `url(/images/etkinlik/${n}.jpeg)`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundColor: "#F7F4EF",
              }}
            />
          ))}

          {/* Satır 2: 3.jpeg, 4.jpeg, 5.jpeg */}
          {[3, 4, 5].map((n) => (
            <div
              key={n}
              className="w-full"
              style={{
                height: "420px",
                backgroundImage: `url(/images/etkinlik/${n}.jpeg)`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundColor: "#F7F4EF",
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

// ─── 4 Values ────────────────────────────────────────────────────────────────
const ValuesSection: React.FC = () => {
  const iconMap: Record<string, React.ReactNode> = {
    Heart: <i className="fa-solid fa-heart text-xl text-brand-bordo" />,
    Star: <i className="fa-solid fa-star text-xl text-brand-gold" />,
    Shield: <i className="fa-solid fa-shield-halved text-xl text-brand-blue" />,
    Users: <i className="fa-solid fa-users text-xl text-brand-green" />,
  };

  return (
    <section className="py-20 bg-bg-page">
      <div className="w-full px-6 xl:px-16">
        <div className="text-center mb-12">
          <h2 className="section-title">Dört Temel Değerimiz</h2>
          <p className="section-subtitle">
            Köklü ama genç, vakarlı ama sıcak, kurumsal ama samimi.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div key={v.title} className="card text-center group">
              <div className="w-14 h-14 rounded-full bg-bg-soft flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                {iconMap[v.icon]}
              </div>
              <h3 className="font-bold text-text-primary text-lg mb-2">
                {v.title}
              </h3>
              <p className="text-text-muted text-sm leading-relaxed">
                {v.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ─── President Message ────────────────────────────────────────────────────────
const PresidentMessage: React.FC = () => {
  const president = boardMembers[0];
  return (
    <section className="py-20 bg-bg-surface">
      <div className="w-full px-6 xl:px-16">
        <div className="flex flex-col md:flex-row gap-10 items-start">
          {/* Sol: fotoğraf + isim */}
          <div className="flex-shrink-0 flex flex-col items-center text-center w-full md:w-48">
            <img
              src="/baskan-foto.jpg"
              alt={president.name}
              className="w-36 h-36 rounded-full object-cover shadow-lg border-4 border-brand-bordo mb-3"
            />
            <div className="font-bold text-text-primary">{president.name}</div>
            <div className="text-text-muted text-sm">{president.role}</div>
          </div>

          {/* Sağ: metin */}
          <div className="flex-1">
            <div className="inline-block text-brand-gold text-sm font-semibold uppercase tracking-wider mb-3">
              Başkandan
            </div>
            <h2 className="text-3xl font-bold text-text-primary mb-5 leading-snug">
              Kıymetli hemşehrilerim,{" "}
              <span className="text-brand-bordo">değerli dostlarımız,</span>
            </h2>
            <p className="text-text-muted leading-relaxed mb-4 text-justify">
              Bursa Trabzonlular Derneği olarak, köklerimizi aldığımız Trabzon'un güçlü kültürünü, kadim değerlerini ve dayanışma ruhunu Bursa'da yaşatmanın büyük onurunu taşıyoruz. Bizim için Trabzon sadece bir şehir değil; aidiyetin, hatıranın, vefanın ve karakterin adıdır. Bursa ise bugün hayat kurduğumuz, emek verdiğimiz, ürettiğimiz ve birlikte geleceğe yürüdüğümüz ortak yuvamızdır. İşte derneğimiz, bu iki güçlü değeri aynı gönülde buluşturan bir birlik çatısıdır.
            </p>
            <p className="text-text-muted leading-relaxed mb-4 text-justify">
              Bizler geçmişine saygı duyan, köklerini unutmayan, büyüklerinden aldığı mirası geleceğe taşımayı görev bilen bir anlayışın temsilcileriyiz. Trabzon'dan taşıdığımız kültür; çalışkanlığı, dürüstlüğü, mertliği, misafirperverliği ve dayanışmayı içinde barındırır. Bu değerleri Bursa'da en güzel şekilde temsil etmek, yaşatmak ve gelecek nesillere aktarmak en önemli sorumluluklarımızdan biridir.
            </p>
            <p className="text-text-muted leading-relaxed mb-4 text-justify">
              Derneğimiz, yalnızca hemşehrilerimizin bir araya geldiği bir yer değil; aynı zamanda dostluğun, paylaşmanın, dayanışmanın ve kardeşliğin evidir. Biz kapsayıcı bir anlayışla hareket ediyoruz. Yaşı, mesleği, düşüncesi, hayat tecrübesi ne olursa olsun; gönlünde Trabzon sevgisi taşıyan, birlik ve beraberlik duygusunu önemseyen herkese kapımız da gönlümüz de açıktır. Çünkü biz inanıyoruz ki gerçek güç, farklılıklarımızı zenginlik bilerek aynı çatı altında kenetlenebilmekten doğar.
            </p>
            <p className="text-text-muted leading-relaxed mb-4 text-justify">
              Özellikle gençlerimiz bizim için çok kıymetlidir. Onların sadece bugünün değil, yarının da taşıyıcıları olduğunun bilincindeyiz. Bu nedenle gençlerimize sahip çıkan, onları kültürel değerleriyle buluşturan, eğitimde, sosyal hayatta ve toplumsal sorumluluk alanlarında destekleyen, yol gösteren bir dernek anlayışını büyütmek istiyoruz.
            </p>
            <p className="text-text-muted leading-relaxed mb-6 text-justify">
              Bu duygu ve düşüncelerle, derneğimize gönül veren, destek olan ve bu büyük aileye değer katan herkese teşekkür ediyorum.
            </p>
            <p className="text-text-muted font-medium mb-4">Saygı ve muhabbetlerimle,</p>
            <Link
              to="/kurumsal/baskandan-mesaj"
              className="inline-flex items-center gap-2 text-brand-bordo font-semibold hover:underline text-sm"
            >
              Tam mesajı oku <i className="fa-solid fa-chevron-right text-xs"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

// ─── Upcoming Events ─────────────────────────────────────────────────────────
const EventsSection: React.FC = () => {
  const categoryColors: Record<string, string> = {
    Kültür: "bg-brand-bordo text-white",
    Gençlik: "bg-brand-blue text-white",
    Aile: "bg-brand-green text-white",
    Genel: "bg-bg-soft text-text-muted",
  };

  const [events, setEvents] = useState<HomeEtkinlik[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(false);
      try {
        const snap = await getDocs(query(collection(db, "etkinlikler"), orderBy("sira", "asc")));
        const list: HomeEtkinlik[] = snap.docs.map((d) => {
          const data = d.data() as any;
          return {
            id: d.id,
            baslik: data.baslik ?? "",
            tarih: data.tarih ?? "",
            yer: data.yer ?? "",
            saat: data.saat ?? "",
            kategori: (data.kategori ?? "").trim() || "Genel",
            aciklama: data.aciklama ?? "",
          };
        });
        if (!cancelled) setEvents(list);
      } catch (e) {
        console.error("Etkinlikler okunamadı:", e);
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const ilkDort = events.slice(0, 4);

  return (
    <section className="py-20 bg-bg-page">
      <div className="w-full px-6 xl:px-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="section-title">Yaklaşan Etkinlikler</h2>
            <p className="text-text-muted">
              Birlikte büyüyoruz. Birlikte hatırlıyoruz. Birlikte yürüyoruz.
            </p>
          </div>
          <Link
            to="/faaliyetler/etkinlikler"
            className="flex items-center gap-2 text-brand-bordo font-semibold hover:gap-3 transition-all text-sm"
          >
            Tüm etkinlikler <i className="fa-solid fa-arrow-right text-xs"></i>
          </Link>
        </div>

        {loading ? (
          <div className="py-10 text-center text-text-soft">
            <i className="fa-solid fa-circle-notch fa-spin text-2xl text-brand-bordo" />
          </div>
        ) : error ? (
          <p className="text-text-muted text-sm">Etkinlikler şu an yüklenemiyor.</p>
        ) : ilkDort.length === 0 ? (
          <p className="text-text-muted text-sm">Yaklaşan etkinlik yok — yenileri yakında burada.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {ilkDort.map((event) => (
              <div
                key={event.id}
                className="card flex flex-col group hover:-translate-y-1 transition-transform"
              >
                <div className="flex items-start justify-between mb-3">
                  <span
                    className={`text-xs font-semibold px-2.5 py-1 rounded-full ${
                      categoryColors[event.kategori || "Genel"] || "bg-bg-soft text-text-muted"
                    }`}
                  >
                    {event.kategori}
                  </span>
                  <i className="fa-regular fa-calendar text-text-soft"></i>
                </div>
                <h3 className="font-bold text-text-primary mb-2 group-hover:text-brand-bordo transition-colors">
                  {event.baslik}
                </h3>
                {event.aciklama ? (
                  <p className="text-text-muted text-sm mb-3 flex-1 leading-relaxed">
                    {event.aciklama}
                  </p>
                ) : (
                  <div className="flex-1 mb-3" />
                )}
                <div className="pt-3 border-t border-border-light">
                  <div className="text-xs text-text-soft">
                    {event.tarih}{event.saat ? ` · ${event.saat}` : ""}
                  </div>
                  {event.yer ? (
                    <div className="text-xs text-text-muted mt-0.5">{event.yer}</div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

// ─── Duyurular ───────────────────────────────────────────────────────────────
const DuyurularSection: React.FC = () => {
  const [duyurular, setDuyurular] = useState<HomeDuyuru[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(false);
      try {
        const snap = await getDocs(query(collection(db, "duyurular"), orderBy("sira", "asc")));
        const list: HomeDuyuru[] = snap.docs.map((d) => {
          const data = d.data() as any;
          return { id: d.id, baslik: data.baslik ?? "", tarih: data.tarih ?? "", aciklama: data.aciklama ?? "" };
        });
        if (!cancelled) setDuyurular(list);
      } catch (e) {
        console.error("Duyurular okunamadı:", e);
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const ilkDort = duyurular.slice(0, 4);

  return (
    <section className="py-20 bg-bg-surface">
      <div className="w-full px-6 xl:px-16">
        <div className="text-center mb-10">
          <h2 className="section-title">Duyurular</h2>
          <p className="section-subtitle">Derneğimizden son haberler ve duyurular.</p>
        </div>

        {loading ? (
          <div className="py-6 text-center text-text-soft">
            <i className="fa-solid fa-circle-notch fa-spin text-2xl text-brand-bordo" />
          </div>
        ) : error ? (
          <p className="text-text-muted text-sm text-center">Duyurular şu an yüklenemiyor.</p>
        ) : ilkDort.length === 0 ? (
          <p className="text-text-muted text-sm text-center">Şu an aktif duyuru yok.</p>
        ) : (
          <div className="max-w-3xl mx-auto space-y-3">
            {ilkDort.map((d) => (
              <div
                key={d.id}
                className="card flex items-start gap-4"
              >
                <div className="w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center flex-shrink-0">
                  <i className="fa-solid fa-bullhorn text-brand-gold" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-text-primary text-sm">{d.baslik}</h3>
                  {d.tarih ? (
                    <div className="text-xs text-text-soft mt-0.5">{d.tarih}</div>
                  ) : null}
                  {d.aciklama ? (
                    <p className="text-sm text-text-muted leading-relaxed mt-2 whitespace-pre-line">
                      {d.aciklama}
                    </p>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

// ─── RSS Haber Tipi ───────────────────────────────────────────────────────────
interface RssItem {
  title: string;
  link: string;
  pubDate: string;
  image: string;
  day: string;
  month: string;
  time: string;
  description: string;
}

const MONTHS_TR = ["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"];

// ─── News ────────────────────────────────────────────────────────────────────
const RSS_SOURCES_TRABZON = [
  `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent("https://rss.sondakika.com/rssnew.aspx?kategori=trabzon")}`,
  `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent("https://www.haberturk.com/rss/trabzon.xml")}`,
  `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent("https://www.sabah.com.tr/rss/trabzon.xml")}`,
];
const RSS_SOURCES_BURSA = [
  `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent("https://rss.sondakika.com/rssnew.aspx?kategori=bursa")}`,
  `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent("https://www.haberturk.com/rss/bursa.xml")}`,
  `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent("https://www.sabah.com.tr/rss/bursa.xml")}`,
];

// Gradient fallback'ler (görsel yoksa)
const FALLBACK_GRADIENTS = [
  "linear-gradient(135deg, #0F4C81 0%, #0a3560 100%)",
  "linear-gradient(135deg, #4E0F26 0%, #3A0A1C 100%)",
  "linear-gradient(135deg, #2E6F57 0%, #1a4035 100%)",
  "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
  "linear-gradient(135deg, #7C3AED 0%, #4C1D95 100%)",
  "linear-gradient(135deg, #B45309 0%, #78350F 100%)",
  "linear-gradient(135deg, #0369A1 0%, #075985 100%)",
  "linear-gradient(135deg, #15803D 0%, #14532D 100%)",
  "linear-gradient(135deg, #9F1239 0%, #881337 100%)",
];

const NewsSection: React.FC = () => {
  const [trabzonItems, setTrabzonItems] = useState<RssItem[]>([]);
  const [bursaItems, setBursaItems] = useState<RssItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    setLoading(true);
    setError(false);

    const decode = (s: string) => s
      .replace(/&amp;apos;/g, "'").replace(/&amp;quot;/g, '"')
      .replace(/&amp;/g, "&").replace(/&apos;/g, "'")
      .replace(/&quot;/g, '"').replace(/&lt;/g, "<").replace(/&gt;/g, ">");

    const parseItems = (data: any): RssItem[] =>
      data.items.map((item: any) => {
        const image = item.thumbnail || item.enclosure?.thumbnail || item.enclosure?.link || "";
        const d = item.pubDate ? new Date(item.pubDate) : new Date();
        return {
          title: decode(item.title || ""),
          link: item.link,
          pubDate: item.pubDate,
          image,
          day: String(d.getDate()).padStart(2, "0"),
          month: MONTHS_TR[d.getMonth()] ?? "",
          time: `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`,
          description: decode(item.description || item.content || ""),
        };
      });

    const fetchOne = (url: string): Promise<RssItem[]> =>
      fetch(url)
        .then((r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
        .then((data) => {
          if (data.status !== "ok" || !data.items?.length) return [];
          return parseItems(data);
        })
        .catch(() => []);

    const fetchMulti = async (urls: string[]): Promise<RssItem[]> => {
      const results = await Promise.all(urls.map(fetchOne));
      const seen = new Set<string>();
      const merged: RssItem[] = [];
      for (const items of results) {
        for (const item of items) {
          if (!seen.has(item.link)) {
            seen.add(item.link);
            merged.push(item);
          }
        }
      }
      merged.sort((a, b) => new Date(b.pubDate).getTime() - new Date(a.pubDate).getTime());
      return merged;
    };

    Promise.all([fetchMulti(RSS_SOURCES_TRABZON), fetchMulti(RSS_SOURCES_BURSA)]).then(([trabzon, bursa]) => {
      if (!trabzon.length && !bursa.length) { setError(true); }
      else {
        setTrabzonItems(trabzon.slice(0, 8));
        setBursaItems(bursa.slice(0, 8));
      }
      setLoading(false);
    });
  }, [retryCount]);

  // Her 5 dakikada bir otomatik yenile
  useEffect(() => {
    const interval = setInterval(() => setRetryCount((c) => c + 1), 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const NewsCard: React.FC<{ item: RssItem; idx: number }> = ({ item, idx }) => (
    <a
      href={item.link}
      target="_blank"
      rel="noopener noreferrer"
      className="relative rounded-xl overflow-hidden group flex flex-1"
      style={{ minHeight: "90px" }}
    >
      {item.image ? (
        <img src={item.image} alt={item.title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
      ) : (
        <div className="absolute inset-0 transition-transform duration-500 group-hover:scale-105"
          style={{ background: FALLBACK_GRADIENTS[idx % FALLBACK_GRADIENTS.length] }} />
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/50 to-black/20" />
      <div className="absolute inset-0 bg-brand-bordo/0 group-hover:bg-brand-bordo/20 transition-colors duration-300" />

      {/* Tarih badge */}
      <div className="relative z-10 flex-shrink-0 flex items-center pl-3">
        <div className="text-white text-center px-2 py-1.5 rounded-lg min-w-[44px]"
          style={{ backgroundColor: "#0F4C81", borderBottom: "3px solid #4E0F26" }}>
          <div className="text-base font-extrabold leading-none">{item.day}</div>
          <div className="text-[9px] font-semibold mt-0.5">{item.month}</div>
        </div>
      </div>

      {/* Başlık + saat */}
      <div className="relative z-10 flex-1 flex flex-col justify-center px-3">
        <h4 className="text-white font-bold text-xs leading-snug line-clamp-2 group-hover:text-brand-gold transition-colors mb-1">
          {item.title}
        </h4>
        <span className="text-white/50 text-[10px] flex items-center gap-1">
          <i className="fa-regular fa-clock" />
          {item.time}
        </span>
      </div>
    </a>
  );

  return (
    <section className="py-16 bg-bg-page">
      <div className="w-full px-6 xl:px-16">

        {/* Başlık */}
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="text-brand-bordo text-sm font-semibold uppercase tracking-widest mb-1">Güncel</div>
            <h2 className="text-3xl font-extrabold text-text-primary">Son Dakika Haberleri</h2>
          </div>
        </div>

        {/* Yükleniyor */}
        {loading && (
          <div className="flex items-center justify-center h-64 text-text-muted gap-3">
            <i className="fa-solid fa-circle-notch fa-spin text-2xl text-brand-bordo" />
            <span>Haberler yükleniyor...</span>
          </div>
        )}

        {/* Hata */}
        {!loading && error && (
          <div className="flex flex-col items-center justify-center h-40 gap-4">
            <div className="flex items-center gap-2 text-text-muted text-sm">
              <i className="fa-solid fa-triangle-exclamation text-brand-bordo text-lg" />
              Haberler şu an yüklenemiyor.
            </div>
            <button
              onClick={() => setRetryCount((c) => c + 1)}
              className="flex items-center gap-2 bg-brand-bordo text-white text-sm font-semibold px-5 py-2 rounded-md hover:bg-brand-bordo-dark transition-colors"
            >
              <i className="fa-solid fa-rotate-right text-xs" />
              Tekrar Dene
            </button>
          </div>
        )}

        {/* 5 Trabzon + 5 Bursa grid */}
        {!loading && !error && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Sol: Trabzon */}
            <div>
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="flex rounded-lg overflow-hidden shadow-sm" style={{ width: 48, height: 32 }}>
                    <div className="flex-1" style={{ background: "#4E0F26" }} />
                    <div className="flex-1" style={{ background: "#0F4C81" }} />
                  </div>
                  <span className="font-bold text-text-primary text-base">Trabzon'dan Haberler</span>
                </div>
                <a href="https://www.sondakika.com/trabzon/" target="_blank" rel="noopener noreferrer"
                  className="text-xs text-brand-blue hover:text-brand-bordo transition-colors flex items-center gap-1">
                  Tümü <i className="fa-solid fa-arrow-right text-[10px]" />
                </a>
              </div>
              <div className="flex flex-col gap-3">
                {trabzonItems.map((item, idx) => (
                  <NewsCard key={item.link + idx} item={item} idx={idx} />
                ))}
              </div>
            </div>
            {/* Sağ: Bursa */}
            <div>
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="flex rounded-lg overflow-hidden shadow-sm" style={{ width: 48, height: 32 }}>
                    <div className="flex-1" style={{ background: "#1a6b3c" }} />
                    <div className="flex-1" style={{ background: "#ffffff", border: "1px solid #e5e7eb" }} />
                  </div>
                  <span className="font-bold text-text-primary text-base">Bursa'dan Haberler</span>
                </div>
                <a href="https://www.sondakika.com/bursa/" target="_blank" rel="noopener noreferrer"
                  className="text-xs text-brand-blue hover:text-brand-bordo transition-colors flex items-center gap-1">
                  Tümü <i className="fa-solid fa-arrow-right text-[10px]" />
                </a>
              </div>
              <div className="flex flex-col gap-3">
                {bursaItems.map((item, idx) => (
                  <NewsCard key={item.link + idx} item={item} idx={idx + 5} />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

// ─── CTA ─────────────────────────────────────────────────────────────────────
const CTASection: React.FC = () => (
  <section className="py-20 bg-gradient-to-br from-brand-bordo-dark via-brand-bordo to-[#6B1535]">
    <div className="w-full px-6 xl:px-16 text-center">
      <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
        Bu Çatının Altında Sana da Yer Var
      </h2>
      <p className="text-white/75 text-lg mb-10 max-w-xl mx-auto leading-relaxed">
        Trabzon'a gönül veren, dayanışmaya inanan, geleceğe birlikte bakmak
        isteyen herkesi bekliyoruz.
      </p>
      <div className="flex flex-wrap gap-4 justify-center">
        <Link
          to="/destek/uyelik"
          className="bg-white text-brand-bordo font-bold px-8 py-3.5 rounded-lg hover:bg-white/90 transition-colors flex items-center gap-2"
        >
          Üyelik Başvurusu <i className="fa-solid fa-arrow-right text-xs"></i>
        </Link>
        <Link
          to="/destek/gonulluluk"
          className="border-2 border-white/50 text-white font-bold px-8 py-3.5 rounded-lg hover:bg-white/10 transition-colors"
        >
          Gönüllü Ol
        </Link>
        <Link
          to="/faaliyetler/etkinlikler"
          className="border-2 border-white/50 text-white font-bold px-8 py-3.5 rounded-lg hover:bg-white/10 transition-colors"
        >
          Takvimi İncele
        </Link>
      </div>
    </div>
  </section>
);

// ─── Page ────────────────────────────────────────────────────────────────────
const Home: React.FC = () => (
  <>
    <HolidayPopup />
    <Hero />
    <BtsoHaberSection />
    <BursDuyuruSection />
    <HaberSection />
    <EtkinlikSection />
    <ValuesSection />
    <PresidentMessage />
    <NewsSection />
    <EventsSection />
    <DuyurularSection />
    <CTASection />
  </>
);

export default Home;
